export default __webpack_public_path__ + "static/media/angularjs-plain.a1b634b2.svg";